import React, { ReactNode } from 'react';
import styled from 'styled-components';

import { opacityModifier } from '@/utils';

type BrandPageContentProps = {
  brandLogo: string;
  brandName: string;
  children: ReactNode;
};

export const BrandPageContentBase = styled.div`
  box-sizing: border-box;
  width: 500px;
  height: 620px;
  background: ${({ theme }) => opacityModifier(theme.color.ui8, 0.7)};
  box-shadow: ${({ theme }) => theme.shadows.outerShadow};
  backdrop-filter: blur(8px);
  border-radius: ${({ theme }) => theme.radius.m};
  padding: 2.5rem;
  display: flex;
  flex-direction: column;
`;

export const BrandPageContentLogo = styled.div`
  margin-bottom: 2.5rem;
`;

export const BrandPageContent: React.FC<BrandPageContentProps> = ({
  brandLogo,
  brandName,
  children,
}) => {
  return (
    <BrandPageContentBase>
      <BrandPageContentLogo>
        <img alt={brandName} src={brandLogo} />
      </BrandPageContentLogo>
      {children}
    </BrandPageContentBase>
  );
};

export const BrandPageContentLeft = styled.div`
  align-items: center;
  bottom: 0;
  box-sizing: border-box;
  display: flex;
  overflow-y: clip;
  padding: 2.5rem;
  position: absolute;
  right: 50%;
  top: 0;
  width: min(50%, 800px);
  z-index: 1;
`;

export const BrandPageContentRight = styled.div`
  align-items: center;
  bottom: 0;
  box-sizing: border-box;
  display: flex;
  overflow-y: clip;
  padding: 2.5rem;
  position: absolute;
  left: 50%;
  top: 0;
  width: min(50%, 800px);
  z-index: 1;
`;
